export const storageKeys = {
  theme: "theme",
};
